import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { IMemberInfo } from './CompanyInfoTypes';

interface ICompanyInfoProp {
  memberInfo: IMemberInfo | undefined;
  loading: boolean;
  // errorMessage: string;
}

const CompanyInfo = ({
  memberInfo,
  loading,
}: // errorMessage,
ICompanyInfoProp) => {
  const {
    addressline1,
    company_ownership_status,
    email,
    first_proposer,
    phone,
    police_station,
    second_proposer,
    user_member_account_status,
    user_member_company_name,
    user_member_representative_name,
    zone_name,
    member_company_website,
  } = memberInfo || {};

  return (
    <div className='box-container h-full'>
      <h2>Company Information</h2>
      {loading ? (
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          {!memberInfo?.user_member_company_name ? (
            <Box sx={{ textAlign: 'center', p: 5 }}>
              <Typography p={3} variant='h4' gutterBottom>
                Update your information
              </Typography>
              <Link to='/new-member-applications'>
                <Button variant='contained' sx={{ fontSize: 12 }}>
                  Click here
                </Button>
              </Link>
            </Box>
          ) : (
            <div className='mt-4 company-info'>
              <ul>
                <li>
                  <span className='info-label'>Organization Name</span>
                  <span className='colon'>:</span>
                  <p>
                    {user_member_company_name
                      ? user_member_company_name
                      : 'Not provided'}
                  </p>
                </li>
                <li>
                  <span className='info-label'>Representative Name</span>
                  <span className='colon'>:</span>
                  <p>
                    {user_member_representative_name
                      ? user_member_representative_name
                      : 'Not provided'}
                  </p>
                </li>
                <li>
                  <span className='info-label'>Organization Ownership Status</span>
                  <span className='colon'>:</span>
                  <p>
                    {company_ownership_status
                      ? company_ownership_status
                      : 'Not provided'}
                  </p>
                </li>
                <li>
                  <span className='info-label'>Account Status</span>
                  <span className='colon'>:</span>
                  <p>
                    <span
                      className={
                        user_member_account_status === 'pending'
                          ? 'pending'
                          : 'approved'
                      }
                    >
                      {user_member_account_status
                        ? user_member_account_status === 'Application Inspection'
                          ? 'Forward for Office Inspection'
                          : user_member_account_status
                        : 'Not provided'}
                    </span>
                  </p>
                </li>
                <li>
                  <span className='info-label'>Full Address</span>
                  <span className='colon'>:</span>
                  <p>{addressline1 ? addressline1 : 'Not provided'}</p>
                </li>
                <li>
                  <span className='info-label'>Organization Zone</span>
                  <span className='colon'>:</span>
                  <p>{zone_name ? zone_name : 'Not provided'}</p>
                </li>
                <li>
                  <span className='info-label'>Police Station</span>
                  <span className='colon'>:</span>
                  <p>{police_station ? police_station : 'Not provided'}</p>
                </li>
                <li>
                  <span className='info-label'>Phone No</span>
                  <span className='colon'>:</span>
                  <p>{phone ? phone : 'Not provided'}</p>
                </li>
                <li>
                  <span className='info-label'>E-mail</span>
                  <span className='colon'>:</span>
                  <p>{email ? email : 'Not provided'}</p>
                </li>
                <li>
                  <span className='info-label'>Website</span>
                  <span className='colon'>:</span>
                  <p>
                    <a
                      href={member_company_website}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {member_company_website
                        ? member_company_website
                        : 'Not provided'}
                    </a>
                  </p>
                </li>
                <li>
                  <span className='info-label'>1st Proposer</span>
                  <span className='colon'>:</span>
                  <p>
                    {first_proposer?.proposer_company_name
                      ? first_proposer.proposer_company_name
                      : 'Not provided'}
                  </p>
                </li>
                <li>
                  <span className='info-label'>2nd Proposer</span>
                  <span className='colon'>:</span>
                  <p>
                    {second_proposer?.proposer_company_name
                      ? second_proposer.proposer_company_name
                      : 'Not provided'}
                  </p>
                </li>
              </ul>
            </div>
          )}
        </Box>
      )}
    </div>
  );
};

export default CompanyInfo;
